const initialState = 1;

const ReservationExchangeRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationExchangeRate":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationExchangeRateReducer;
